import { Icon } from './Icon'
import { Tooltip } from './Tooltip'

interface LegendInfoIconProps {
  /** The explanatory copy surfaced by hover or keyboard focus. */
  tooltip: string
  /** Optional accessible label override; defaults to "More information". */
  ariaLabel?: string
}

/**
 * A small ⓘ icon used inside legend chips. Shared so every legend item
 * surfaces a consistent affordance for hover / keyboard explanation.
 */
export function LegendInfoIcon({
  tooltip,
  ariaLabel = 'More information',
}: Readonly<LegendInfoIconProps>): JSX.Element {
  return (
    <Tooltip content={tooltip} placement="top">
      <span
        data-testid="legend-info-icon"
        role="button"
        tabIndex={0}
        aria-label={ariaLabel}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 16,
          height: 16,
          borderRadius: '50%',
          cursor: 'help',
          color: 'inherit',
          opacity: 0.7,
        }}
      >
        <Icon name="info" size={14} color="currentColor" />
      </span>
    </Tooltip>
  )
}
